<template>
    <div>
        <DashboardComponent />
    </div>
</template>
  
<script>
import DashboardComponent from '@/components/DashboardComponent.vue';

export default {
    components: {
        DashboardComponent
    },
};
</script>